import { Directive, HostListener, ElementRef, Input, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';
import { DataService } from '../../_services';

@Directive({
  selector: '[appEmailNdMobileNoOnly]'
})
export class EmailMobilenoOnlyDirective implements OnInit {
  @Input('loginType') loginType: string = 'number'; // number | decimal

  private regex = {
    number: new RegExp(/^\d+$/),
     email: new RegExp(/^[0-9]+(\.[0-9]*){0,1}$/g)
  };

  private specialKeys = {
    number: ['Enter', 'Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Delete', 'Control'],
    //email: ['Enter', 'Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Delete', 'Control', 'v', 'V', 'c', 'C'],
  };

  constructor(
    private el: ElementRef,
    private dataService: DataService
  ) {
  }

  ngOnInit() {
  }


  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (this.specialKeys[this.loginType].indexOf(event.key) !== -1) {
      return;
    }
    let val: string = this.el.nativeElement.value;
    const isMobileNo = this.dataService.isMobileNo(val);
    console.log(isMobileNo);
    
    console.log(val.length);
    
    if (isMobileNo && val.length >9) {
      event.preventDefault();
    } else {
      if (val.length > 100) {
        event.preventDefault();
      }
    }
  }

}

